/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { api } from 'services/api/index';

import { IHostnameParam } from 'types/IHostnameParam';
import { IAppConfiguration } from 'types/IAppConfiguration';

export async function getAppConfigurations(
  config: IHostnameParam
): Promise<IAppConfiguration[]> {
  try {
    const { hostname } = config;

    const response = await api.get(`/app-configurations`, {
      ...(hostname ? { headers: { 'x-domain': hostname } } : {}),
      params: { status: 'active' },
    });

    return response.data;
  } catch (error) {
    console.error('[getAppConfigurations]', error.message);
    return [];
  }
}
